import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "news_show"
};
const _hoisted_2 = {
  class: "news_info"
};
const _hoisted_3 = {
  class: "news_title"
};
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    title: "信息详情",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("dl", null, [_createElementVNode("dt", null, _toDisplayString($setup.news.title), 1), _createElementVNode("dd", null, "发布时间：" + _toDisplayString($setup.news.uptime), 1)])]), _createElementVNode("div", {
    class: "news_xq",
    innerHTML: $setup.news.content
  }, null, 8, _hoisted_4)])]);
}